'use client'
import { motion, type Variants } from 'framer-motion'
import { ApplicationForm } from '@/components/Forms/ApplicationForm'

const headingVariants: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.15, delayChildren: 0.1 } },
}
const itemVariants: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
}

export function CareersSection() {
  return (
    <section id="careers" className="relative overflow-hidden py-24">
      {/* CDL driver background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url(/images/careers-cdl.png)' }}
        aria-hidden
      />
      {/* Solid base overlay */}
      <div className="absolute inset-0 bg-[#0f172a]/78" />
      {/* Gradient: brighter center fading to dark edges */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'linear-gradient(to bottom, rgba(15,23,42,0.6) 0%, rgba(15,23,42,0.2) 40%, rgba(15,23,42,0.7) 100%)',
        }}
      />

      <div className="relative z-10 page-container">
        <motion.div
          className="text-center mb-12"
          variants={headingVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-80px' }}
        >
          <motion.p
            variants={itemVariants}
            className="text-sm font-semibold tracking-widest uppercase text-[color:var(--accent)] opacity-80 mb-3"
          >
            Owner Operators &amp; Company Drivers
          </motion.p>
          <motion.h2
            variants={itemVariants}
            className="text-3xl md:text-5xl font-bold text-white tracking-tight"
          >
            Drive With Us
          </motion.h2>
          <motion.p
            variants={itemVariants}
            className="mt-4 text-white/70 text-lg max-w-2xl mx-auto leading-relaxed"
          >
            CDL-A required. Competitive pay, consistent miles, and a team that
            has your back from dispatch to delivery.
          </motion.p>
        </motion.div>

        <motion.div
          className="max-w-2xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.7, ease: 'easeOut', delay: 0.2 }}
        >
          <ApplicationForm />
        </motion.div>
      </div>
    </section>
  )
}
